import { CONFIG } from "../../actions/actionConstants.js";

const requestConfig = url => {
  return {
    type: CONFIG.REQUEST,
    payload: { url }
  };
};

const receiveConfig = data => {
  return {
    type: CONFIG.RECEIVE,
    payload: data
  };
};

const failureConfig = response => {
  return {
    type: CONFIG.FAILURE,
    payload: response
  };
};

// using the following export pattern so we can mock more easily using jest

const configActions = {
  requestConfig,
  receiveConfig,
  failureConfig
};

export default configActions;
